import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import {
  getFIPeople,
  fetchFIPeople,
  deleteFIPerson,
} from 'src/financial-institution';
import {
  reduceServerErrors,
  setBreadcrumbs,
  ConfirmDeletionModal,
  UiToastAdapter,
} from 'src/ui';
import { ClientSidePagingManager } from 'src/api';

import { sendInvite } from 'src/auth';
import { getUser, impersonateAccount } from '../redux';
import { UsersTable } from '../components';

class UsersListPage extends Component {
  state = {
    loading: true,
    listPeople: [],
    archivingUser: null,
  };

  constructor(props) {
    super(props);

    const { fetchFIPeople } = this.props;

    this.pagedPeople = new ClientSidePagingManager(
      fetchFIPeople,
      () => this.props.people.items, // eslint-disable-line react/destructuring-assignment
      listPeople => {
        this.setState({ listPeople });
      }
    );
  }

  async componentDidMount() {
    const { setBreadcrumbs, user, impersonateAccount } = this.props;

    setBreadcrumbs([{ label: 'Users', href: '/users' }]);

    await impersonateAccount({});

    await this.pagedPeople.fetch({
      financialInstitutionId: user.financialInstitutionId,
    });

    const { people } = this.props;

    if (people.isError()) {
      reduceServerErrors(people);
    }

    this.setState({ loading: false });
  }

  onArchive = async user => {
    this.setState({ archivingUser: user });
  };

  onCancelArchiveUser = () => {
    this.setState({ archivingUser: null });
  };

  onSendInvite = async user => {
    const { emailAddress, firstName, lastName } = user;
    this.setState({ loading: true });

    const result = await sendInvite(emailAddress);

    if (result.ok) {
      toast(
        UiToastAdapter(
          `Invite successfully sent to ${firstName} ${lastName}.`,
          'success'
        )
      );
    } else {
      toast(
        UiToastAdapter(
          (result.error.body && result.error.body.detail) ||
            `An error occurred while sending an invite for the requested person.`,
          'danger'
        )
      );
      console.error(result.error.body);
    }

    this.setState({ loading: false });
  };

  onConfirmArchiveUser = async () => {
    const { deleteFIPerson, user } = this.props;
    const { archivingUser } = this.state;

    this.setState({ loading: true, archivingUser: null });

    await deleteFIPerson({
      financialInstitutionId: user.financialInstitutionId,
      personId: archivingUser.id,
    });

    const { people } = this.props;
    if (people.isError()) {
      reduceServerErrors(people);
    } else {
      this.pagedPeople.refresh();
      toast(UiToastAdapter('User archived successfully!', 'success'));
    }

    this.setState({ loading: false });
  };

  render() {
    const { loading, listPeople, archivingUser } = this.state;

    return (
      <>
        <Columns isMultiline>
          <Column isSize="1/2">
            <MuiTitle isSize="4" hasTextColor="info" tag="h2">
              Users
            </MuiTitle>
          </Column>
          <Column isSize="1/2" hasTextAlign="right">
            <NavLink
              className="button is-gradient-bright is-long"
              to="/users/add"
            >
              <span className="icon is-left">
                <FontAwesomeIcon icon={['fal', 'plus']} />
              </span>
              <span>Add User</span>
            </NavLink>
          </Column>
          <Column>
            <UsersTable
              loading={loading}
              users={listPeople}
              paging={this.pagedPeople}
              onDeleteUser={this.onArchive}
              onSendInvite={this.onSendInvite}
            />
          </Column>
        </Columns>
        <ConfirmDeletionModal
          isActive={!!archivingUser}
          onClickCancel={this.onCancelArchiveUser}
          onClickConfirm={this.onConfirmArchiveUser}
          title={(archivingUser || {}).name || ''}
        />
      </>
    );
  }
}

UsersListPage.propTypes = {
  user: propTypes.object.isRequired,
  people: propTypes.object.isRequired,
  fetchFIPeople: propTypes.func.isRequired,
  deleteFIPerson: propTypes.func.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  impersonateAccount: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    people: getFIPeople(state),
  };
}

const connectedUsersListPage = connect(mapStateToProps, {
  fetchFIPeople,
  setBreadcrumbs,
  deleteFIPerson,
  impersonateAccount,
})(UsersListPage);

export { connectedUsersListPage as UsersListPage };
